import { c as _c } from "react/compiler-runtime";
import type { InterestRate } from "@justhome/api-core";
import { FC, useMemo } from "react";
import toMonthlyRates from "./toMonthlyRates";
const formatRate = (rate?: number) => rate === undefined ? "–" : `${rate.toLocaleString("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})} %`;

// Server-rendered so the figures behind the chart canvas are readable by search and answer
// engines, and by anyone who cannot use the chart.
const RateTable: FC<{
  observations: InterestRate[];
}> = t0 => {
  const $ = _c(17);
  const {
    observations
  } = t0;
  let t1;
  if ($[0] !== observations) {
    t1 = toMonthlyRates(observations);
    $[0] = observations;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const rows = t1;
  if (!rows.length) {
    return null;
  }
  const t2 = rows.length === 1 ? "Bauzinsen des letzten Monats als Tabelle" : `Bauzinsen der letzten ${rows.length} Monate als Tabelle`;
  let t3;
  if ($[2] !== t2) {
    t3 = <summary className="cursor-pointer text-primary-800 focusable rounded-s w-fit">{t2}</summary>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== rows[0].label) {
    t4 = <caption className="sr-only">Durchschnittlicher Sollzins pro Monat nach Zinsbindung, Stand{" "}{rows[0].label}</caption>;
    $[4] = rows[0].label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <thead><tr className="border-b border-neutral-50"><th scope="col" className="py-2xs pr-s font-book">Monat</th><th scope="col" className="py-2xs pr-s font-book">10 Jahre</th><th scope="col" className="py-2xs pr-s font-book">15 Jahre</th><th scope="col" className="py-2xs font-book">20 Jahre</th></tr></thead>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== rows) {
    t6 = rows.map(_temp);
    $[7] = rows;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <tbody>{t6}</tbody>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t7) {
    t8 = <div className="overflow-x-auto mt-s"><table className="w-full text-left tabular-nums">{t4}{t5}{t7}</table></div>;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t3 || $[15] !== t8) {
    t9 = <details className="text-body-2">{t3}{t8}</details>;
    $[14] = t3;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
export default RateTable;
function _temp(row) {
  return <tr key={row.month} className="border-b border-neutral-50"><th scope="row" className="py-2xs pr-s font-normal"><time dateTime={row.month}>{row.label}</time></th><td className="py-2xs pr-s">{formatRate(row.tenYears)}</td><td className="py-2xs pr-s">{formatRate(row.fifteenYears)}</td><td className="py-2xs">{formatRate(row.twentyYears)}</td></tr>;
}